import {
  faClone,
  faCodeBranch,
  faGripVertical,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMapSigns,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Input, Modal, Popover } from 'antd';
import React from 'react';
import styled, { injectGlobal } from 'styled-components';

import ConditionsProcess from './ConditionsProcess';

const confirm = Modal.confirm;

export interface IProcessPageProps {
  onClickRemoveButton: Function;
  onDuplicatePage: any;
  onTitlePageChange: Function;
  titlePageValue: string;
  idxPage: number;
  setCurrentPage: Function;
  sectionLinked: any;
  sectionLinkedSelect?: string;
  sectionLinkOnChange: Function;
  isActive: boolean;
  currentPage: any;
  pagesGoThisPage: any;
  valueIDPage: string;
  pageComponents: any;
  isBroken?: boolean
  componentsInvalid?: boolean;
  removeConditions: Function;
}

interface IProcessPageState {
  activePage: boolean;
  conditionModalVisible: boolean;
  currentPage: any,
  comeFromPages: any,
  visiblePagePath: boolean
  visibleOptionsConditions: boolean;
}

export default class ProcessPage extends React.Component<IProcessPageProps, IProcessPageState> {


  constructor(props: IProcessPageProps) {
    super(props);
    this.state = {
      activePage: false,
      conditionModalVisible: false,
      currentPage: [],
      comeFromPages: [],
      visiblePagePath: false,
      visibleOptionsConditions: false
    }
  }

  showDeleteConfirm(onDelete: Function) {
    confirm({
      title: I18n.l("formflow.labels.titleRemoveComponent"),
      content: I18n.l("formflow.labels.removeSection"),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  showDeleteConditions(onDelete: Function) {
    confirm({
      title: I18n.l("process.lite.removeConditionTitle"),
      content: I18n.l("process.lite.removeConditionDescription"),
      okText: I18n.l("common.delete"),
      okType: 'primary',
      cancelText: I18n.l("common.cancel"),
      onOk() {
        onDelete()
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  handleCondition = async () => {
    this.setState({
      conditionModalVisible: !this.state.conditionModalVisible,
      currentPage: this.props.currentPage,
      visibleOptionsConditions: false
    });
  }
  onCloseModal = async () => {
    this.setState({ conditionModalVisible: false })
  }

  getTitleComponentCondition() {
    let titleComponentCondition: any
    this.props.pageComponents.forEach((components: any) => {

      if (components.id === this.props.pageComponents[0].rules[0].xItem.id) {
        titleComponentCondition = components.title
      }
    })
    return titleComponentCondition
  }

  UNSAFE_componentWillReceiveProps = async (nextProps: any) => {
    const {
      pagesGoThisPage
    } = this.props

    if (pagesGoThisPage !== nextProps.pagesGoThisPage) {
      this.setState({ comeFromPages: nextProps.pagesGoThisPage })
    }
  }

  routePageComponent() {
    let components: JSX.Element[] = []
    const {
      comeFromPages
    } = this.state

    const {
      sectionLinked,
      sectionLinkedSelect
    } = this.props
    if (sectionLinkedSelect === 'end' && sectionLinked.length < 1) {
      components.push(
        <li key={sectionLinkedSelect}><Icon icon={faLongArrowAltRight} /> {I18n.l("label.pages.path.goTo")}: {I18n.l("label.pages.path.end")}</li>
      )
    }
    for (let page of comeFromPages) {
      components.push(
        <li key={page}>{I18n.l("label.pages.path.comeFrom")}: {page} <Icon icon={faLongArrowAltLeft} /></li>
      )
    }
    let uniqueEnd = false
    for (let s of sectionLinked) {
      if (s.id === sectionLinkedSelect) {
        components.push(
          <li key={s.id}><Icon icon={faLongArrowAltRight} /> {I18n.l("label.pages.path.goTo")}: {s.title}</li>
        )
      }
      if (sectionLinkedSelect === 'end' && !uniqueEnd) {
        components.push(
          <li key={s.id}><Icon icon={faLongArrowAltRight} /> {I18n.l("label.pages.path.goTo")}: {I18n.l("label.pages.path.end")}</li>
        )
        uniqueEnd = true;
      }
    }

    return (
      <ListPathPages><ul>{components}</ul></ListPathPages>
    )

  }

  hidePopoverPath = () => {
    this.setState({
      visiblePagePath: false,
    });
  }

  handleOptionsConditions = async () => {
    this.setState({
      visibleOptionsConditions: !this.state.visibleOptionsConditions,
    });
  }

  handleVisiblePagePath = (visiblePagePath: boolean) => {
    this.setState({ visiblePagePath });
  };

  getOptionsConditions() {
    const options: JSX.Element[] = [];

    options.push(
      <>
        <div >
          <a >{I18n.l("label.settings")}</a>
        </div>
        <div >
          <a onClick={() => this.showDeleteConditions(() => this.props.removeConditions())} >{I18n.l("process.lite.removeConditionTitle")}</a>
        </div>
      </>
    )
    return options;
  }

  render() {
    const {
      onTitlePageChange,
      titlePageValue,
      onDuplicatePage,
      onClickRemoveButton,
      isActive,
      setCurrentPage,
      valueIDPage,
      isBroken,
      componentsInvalid
    } = this.props;

    return (
      <>
        <CardPage onPointerDown={() => setCurrentPage()} style={isActive && !isBroken && !componentsInvalid ? { backgroundColor: "#F6FCFD" } : isBroken || componentsInvalid ? { backgroundColor: '#FFE8E8' } : {}}>
          <div>
            <Icon icon={faGripVertical} />
            <Input
              maxLength={65}
              value={titlePageValue}
              onChange={onTitlePageChange()}
            />
            <span style={{ float: 'right', marginTop: '8px', cursor: 'pointer' }}>
              <span onPointerDown={this.handleCondition} >
                {(this.props.currentPage.conditions && this.props.currentPage.conditions.length > 0) &&
                  <span style={{ paddingRight: '5px', fontWeight: 'bold', color: this.props.isBroken ? 'red' : '' }}>{this.props.currentPage.conditions ? this.props.currentPage.conditions.length : ''}</span>
                }
                <Icon style={{ marginRight: '1rem', transform: 'rotate(90deg)' }} icon={faCodeBranch} color={this.props.isBroken ? 'red' : ''} />
              </span>
              <span onPointerDown={() => this.showDeleteConfirm(onClickRemoveButton())}>
                <Icon style={{ marginRight: '1rem' }} icon={faTrash} />
              </span>
              <span style={{ zIndex: 999 }} onPointerDown={() => onDuplicatePage()} >
                <Icon icon={faClone} />
              </span>
            </span>
          </div>
          <div className="pathPages">
            <div className="pathPagesContent">
              <Popover
                content={this.routePageComponent()}
                trigger="click"
                placement="rightTop"
                visible={this.state.visiblePagePath}
                onVisibleChange={this.handleVisiblePagePath}
                overlayClassName="popover-path"
              >
                <Button type="ghost" className="button-popover"><Icon icon={faMapSigns} className="icon" /><span>{I18n.l("process.seePaths")}</span></Button>
              </Popover>
            </div>
          </div>
          {this.props.isBroken &&
            <div style={{ color: 'red', marginTop: '10px', marginBottom: '-10px', fontWeight: 'bold' }}>
              {I18n.l("label.pages.isBroken").toUpperCase()}
            </div>
          }
          {this.props.componentsInvalid &&
            <div style={{ color: 'red', marginTop: '10px', marginBottom: '-10px', fontWeight: 'bold' }}>
              {I18n.l("label.pages.componentInvalid").toUpperCase()}
            </div>
          }
        </CardPage >
        {
          this.state.conditionModalVisible && (
            <ConditionsProcess
              modalVisible={this.state.conditionModalVisible}
              onCloseModal={this.onCloseModal}
              titleConditionModal={valueIDPage}
              subtitleConditionModal={''}
              currentPage={this.props.currentPage}
            />
          )
        }
      </>
    );
  }
}

//#region CSS


injectGlobal`
  .popover-path {
    .ant-popover-inner, .ant-popover-arrow {
      background-color: #40464D
    }
  }
`
const ListPathPages = styled.div`
  ul {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      margin: 3px 0;
      padding: 0;
      color: #fff;

      .svg-inline--fa {
        margin-right: 5px;
        vertical-align: -0.25em
      }
    }
  }
`
const CardPage = styled.div`
cursor: all-scroll;
padding: 20px 20px 20px 20px;
height:auto;
border-bottom: 1px solid  ${Theme.secondary.lightGrey};
background-color: #fff;
&:hover  {
  background-color:'#E0F4F8'
}
input[type="text"] {
    margin-left: 10px;
    width: 150px;
}
.input-select-page {
    width: 150px;
    margin-top: 5px;
}

.pathPages {
  padding-top: 10px;
  .ant-btn-ghost:hover, .ant-btn-ghost:focus {
    background-color: none;
    border-color: none;
    color: #666
  }  
  [ant-click-animating-without-extra-node]:after {
    animation: 0s !important;
    border-color: transparent !important;
  }
  .button-popover {
    background: none;    
    border: 0;    
    .icon {
      position: absolute;
      margin-top: 5px;
    }
    span{
      margin-left: 20px;
    }    
  }
}
`